export default "__VITE_ASSET__DoNp0l1a__"